// hooks/useCreateNewReservation.ts
import { useDispatch, useSelector } from 'react-redux';
import { baseStore, RootState } from '../store'; // Adjust the import based on your file structure
import Logger from '../helpers/logger';
import ErrorTracker from '../helpers/errorTracker';
import { locationsApiSlice } from '../../api/locations/locationsApiSlice';
import { setAllGroupsByLocation } from '../slice/booking/bookingSlice';
import { notifyLoadFailure, queryResultError } from '../helpers/failureNotification';


const fetchAllGroupsCall = async(locationIds: string[]) => {    
    const data = await baseStore.dispatch(
        locationsApiSlice.endpoints.getAssetGroupsByLocationIdsList.initiate({
            locationIds: locationIds,
        })
    )
    return data;
};

export const useFetchAllGroups = () => {
  const locations = useSelector((state: RootState) => state.booking.locations);
  const dispatch = useDispatch();

  const fetchAllGroups = async () => {
    try {
        if (locations && locations.length > 0) {
            const locationIds = locations.map((location: any) => location.id);
            const result = await fetchAllGroupsCall(locationIds);
            // `initiate` resolves with `{ error }` instead of throwing, so
            // without this check the failure was invisible (#1970).
            const failure = queryResultError(result);
            if (failure) {
                Logger.for('fetchAllGroups').error(failure);
                ErrorTracker.trackException(failure as Error);
                notifyLoadFailure(dispatch, 'book_location.error.fetch_equipment');
            }
            if (result.data) {
                dispatch(setAllGroupsByLocation({ locationIds: locationIds, assetGroups: result.data }));
            }

        }
    } catch (error) {
      Logger.for('createNewReservation').error(error);
      ErrorTracker.trackException(error as Error);
      notifyLoadFailure(dispatch, 'book_location.error.fetch_equipment');
    }
  };

  return fetchAllGroups;
};
